import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { UICustomizationService } from '../../services/ui-customization.service';

@Component({
  selector: '[uiCustomization]',
  template: `<ng-content></ng-content>`
})
export class UICustomizationDirective {

  constructor(private uiCustomizationService: UICustomizationService,
              private element: ElementRef) { }

  @Input()
  set elementName(elementName: string) {
    const uiCustomResource = this.uiCustomizationService.getUICustomResource(elementName);
    if (!uiCustomResource || !uiCustomResource.properties) {
      return;
    }
    if (!uiCustomResource.properties.visible) {
      this.element.nativeElement.style.display = 'none';
    }
    if (uiCustomResource.properties.disabled) {
      this.element.nativeElement.disabled = true;
    }
  }
}
